import { useQuery } from 'react-query';
import { getEmailDetails } from '../../api/getEmailDetails';

export function useEmailDetails(emailId: string) {
  return useQuery([`emailDetails`, emailId], () => getEmailDetails(emailId), {
    refetchOnWindowFocus: false,
  });
}
